"use client";
import { ArrowRight } from "lucide-react";
import { FC } from 'react';
import style from '@/assets/styling/scss/stories.module.scss';
import Link from 'next/link';
import { FormattedMessage } from "@/components/elements";
import { motion } from 'framer-motion';

interface ImageItem {
  id: string;
  attributes: {
    caption: string;
    url: string;
    width: number;
    height: number;
  };
}

interface InformationAttributes {
  name: string;
  title: string;
  description: string;
}

interface StoryProps {
  id: string;
  information: InformationAttributes;
  image: ImageItem[];
}

const childVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.95 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: {
      duration: 0.3,  
      ease: [0.25, 0.8, 0.5, 1], 
    }
  },
};

const Story: FC<StoryProps> = ({ id, image, information }) => {
  const { name, title, description } = information;
  const { caption, url, width, height } = image[0]?.attributes || {};

  return (
    <motion.article
      variants={childVariants}
      className={style.story}
      onClick={() => (window.location.href = `/for-companies/success-stories/${id}/`)}
    >
      <div className={style.imageWrapper}>
        <img
          className={style.image}
          src={url}
          width={width}
          height={height}
          alt={caption}
        />
      </div>
      <h3 className={style.name}>{name.toUpperCase()}</h3>
      <h2 className={style.title}>{title}</h2>
      <p className={style.description}>{description}</p>
      <Link
        className={style.button}
        href={`/for-companies/success-stories/${id}/`}
        scroll={true}
      >
        <FormattedMessage id="read_more" />
        <ArrowRight />
      </Link>
    </motion.article>
  );
};

export default Story;
